'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _Object$getOwnPropertySymbols = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _Object$getOwnPropertyDescriptor = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _Object$getOwnPropertyDescriptors = require('@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors');
var _Object$defineProperties = require('@babel/runtime-corejs3/core-js-stable/object/define-properties');
var _Object$defineProperty = require('@babel/runtime-corejs3/core-js-stable/object/define-property');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _get = require('@babel/runtime-corejs3/helpers/get');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
require('../expression/index.js');
var patternAggregation_model = require('./pattern-aggregation.model.js');
var patternEntity_model = require('./pattern-entity.model.js');
var patternOrderBy_model = require('./pattern-order-by.model.js');
var parseJson = require('../expression/parse-json.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _Object$getOwnPropertySymbols__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertySymbols);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _Object$getOwnPropertyDescriptor__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertyDescriptor);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _Object$getOwnPropertyDescriptors__default = /*#__PURE__*/_interopDefaultLegacy(_Object$getOwnPropertyDescriptors);
var _Object$defineProperties__default = /*#__PURE__*/_interopDefaultLegacy(_Object$defineProperties);
var _Object$defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_Object$defineProperty);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);

function ownKeys(e, r) { var t = _Object$keys__default["default"](e); if (_Object$getOwnPropertySymbols__default["default"]) { var o = _Object$getOwnPropertySymbols__default["default"](e); r && (o = _filterInstanceProperty__default["default"](o).call(o, function (r) { return _Object$getOwnPropertyDescriptor__default["default"](e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context9, _context10; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty__default["default"](_context9 = ownKeys(Object(t), !0)).call(_context9, function (r) { _defineProperty__default["default"](e, r, t[r]); }) : _Object$getOwnPropertyDescriptors__default["default"] ? _Object$defineProperties__default["default"](e, _Object$getOwnPropertyDescriptors__default["default"](t)) : _forEachInstanceProperty__default["default"](_context10 = ownKeys(Object(t))).call(_context10, function (r) { _Object$defineProperty__default["default"](e, r, _Object$getOwnPropertyDescriptor__default["default"](t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PatternVertexSet = /*#__PURE__*/function (_PatternEntity) {
  // limitIsParam: boolean;
  // limitParamName?: string;

  function PatternVertexSet(data, schema) {
    var _context, _context2, _context3;
    var _this;
    _classCallCheck__default["default"](this, PatternVertexSet);
    _this = _callSuper(this, PatternVertexSet, [data]);
    _this.vertices = data.vertices || [];
    _this.isParam = data.isParam;
    _this.ids = data.ids;
    _this.paramName = data.paramName;
    _this.filters = data.filters ? _mapInstanceProperty__default["default"](_context = data.filters).call(_context, function (filterJson) {
      return parseJson.parseExprJson(filterJson, schema);
    }) : [];
    _this.aggregations = data.aggregations ? _mapInstanceProperty__default["default"](_context2 = data.aggregations).call(_context2, function (aggJson) {
      return new patternAggregation_model.PatternAggregation(aggJson, schema);
    }) : [];
    _this.orderBy = data.orderBy ? _mapInstanceProperty__default["default"](_context3 = data.orderBy).call(_context3, function (orderByJson) {
      return new patternOrderBy_model.PatternOrderBy(orderByJson, schema);
    }) : [];
    // this.limitIsParam = data.limitIsParam;
    // this.limitParamName = data.limitParamName;
    _this.hasLimit = data.hasLimit || false;
    _this.limit = data.limit;
    return _this;
  }
  _inherits__default["default"](PatternVertexSet, _PatternEntity);
  return _createClass__default["default"](PatternVertexSet, [{
    key: "toJson",
    value: function toJson() {
      var _context4, _context5, _context6, _context7, _context8;
      return _objectSpread(_objectSpread({}, _get__default["default"](_getPrototypeOf__default["default"](PatternVertexSet.prototype), "toJson", this).call(this)), {}, {
        vertices: _sliceInstanceProperty__default["default"](_context4 = this.vertices).call(_context4),
        isParam: this.isParam,
        ids: _sliceInstanceProperty__default["default"](_context5 = this.ids).call(_context5),
        paramName: this.paramName,
        filters: _mapInstanceProperty__default["default"](_context6 = this.filters).call(_context6, function (filter) {
          return filter.toJson();
        }),
        aggregations: _mapInstanceProperty__default["default"](_context7 = this.aggregations).call(_context7, function (agg) {
          return agg.toJson();
        }),
        orderBy: _mapInstanceProperty__default["default"](_context8 = this.orderBy).call(_context8, function (orderBy) {
          return orderBy.toJson();
        }),
        // limitIsParam: this.limitIsParam,
        // limitParamName: this.limitParamName,
        hasLimit: this.hasLimit,
        limit: this.limit
      });
    }
  }]);
}(patternEntity_model.PatternEntity);

exports.PatternVertexSet = PatternVertexSet;
